import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import uuidV4 from "uuid/v4";

// STATE AND STORE
// LIBS
import { sumFormat } from "../../../lib/helpers/strings";

// UI
import { Row, Col, Header, Button, Table, Section } from "../../../ui";

export default class FilialPrices extends Component {
  static propTypes = {
    filialId: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    prices: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => 1 + i
      },
      {
        title: "Страна",
        suffix: "Производителя",
        render: ({ item }) => item.prices_countrys_id.title
      },
      {
        title: "Проба",
        suffix: "золота",
        render: ({ item }) => {
          let probsList = [];

          if (item.probs && item.probs.length) {
            probsList = item.probs.map(prob => {
              return <div key={uuidV4}>{prob.prices_probs_id.title}</div>;
            });
          }

          return probsList;
        }
      },
      {
        title: "Новое",
        suffix: "состояние",
        text: "right",
        render: ({ item }) => {
          let probsList = [];

          if (item.probs && item.probs.length) {
            probsList = item.probs.map(prob => {
              return <div key={uuidV4}>{sumFormat(prob.price_new)}</div>;
            });
          }

          return probsList;
        }
      },
      {
        title: "Нормальное",
        suffix: "состояние",
        text: "right",
        render: ({ item }) => {
          let probsList = [];

          if (item.probs && item.probs.length) {
            probsList = item.probs.map(prob => {
              return <div key={uuidV4}>{sumFormat(prob.price_normal)}</div>;
            });
          }

          return probsList;
        }
      },
      {
        title: "Лом",
        suffix: "состояние",
        text: "right",
        render: ({ item }) => {
          let probsList = [];

          if (item.probs && item.probs.length) {
            probsList = item.probs.map(prob => {
              return <div key={uuidV4}>{sumFormat(prob.price_crack)}</div>;
            });
          }

          return probsList;
        }
      }
    ];
  };

  render() {
    return (
      <div>
        <Row align="center" withMain={true}>
          <Col padding="no" main={true}>
            <Header size={4}>Расценки</Header>
          </Col>
          <Col padding="no" normal={true}>
            <Button
              size="s"
              type="as"
              as={Link}
              to={`/filials/${this.props.filialId}/prices/edit`}
            >
              {this.props.prices && this.props.prices.length
                ? "Изменить"
                : "Создать"}
              {" расценки"}
            </Button>
          </Col>
        </Row>

        <Table
          columns={this.getTableColumns()}
          data={this.props.prices}
          loading={this.props.loading}
        />

        <Section theme="warning">
          <strong>Внимание!</strong> Расценки изменяются для каждого филиала по
          отдельности.
        </Section>
      </div>
    );
  }
}
